export const API_HOST = "/api";
export const UI_HOST = "http://localhost:3000";
